import { render } from "./EditarPedidoMinimo.vue?vue&type=template&id=33849d8c"
import script from "./EditarPedidoMinimo.vue?vue&type=script&lang=js"
export * from "./EditarPedidoMinimo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__